<script lang="ts">
    import type {Rec} from 'src/typings';
    import {getInjector, getLocalization} from 'src/core';
    import {KpCollectionSingleInsertButtonPresenter} from './kp-collection-inser-insert-button.presenter';

    export let record: Rec;

    const localize = getLocalization();
    const presenter = getInjector().getByClass(KpCollectionSingleInsertButtonPresenter);

    let isDisabled = false;

    async function insert() {
        isDisabled = true;
        try {
            await presenter.insertToCollection(record);
        } finally {
            isDisabled = false;
        }
    }

</script>

<button type="button"
        class="btn btn-block btn-default"
        disabled={isDisabled}
        on:click={insert}>
    {localize(/* @kp-localization recordCollections.AddToCollection */ 'recordCollections.AddToCollection')}
</button>